module.exports = __webpack_public_path__ + "img/brave1-min.jpg";